import {CategoryColumn} from '@models/adminstration/portal-setup/machine-category/category-column';

export class MachineCategoryColumnConfiguration {
  parentId: number;
  referenceMachineId: number;
  id: number;
  categoryName: string;
  categoryDisplayName: string;
  categoryIcon: string;
  categoryColumns: CategoryColumn[];
  machinesCount?: number = 0;
  isCollapsed?: boolean = false;


  constructor(config?: MachineCategoryColumnConfiguration) {
    this.parentId = config?.parentId || -1;
    this.referenceMachineId = config?.referenceMachineId || -1;
    this.id = config?.id || 0;
    this.categoryName = config?.categoryName || '';
    this.categoryDisplayName = config?.categoryDisplayName || '';
    this.categoryIcon = config?.categoryIcon || '';
    this.categoryColumns = config?.categoryColumns ? [...config?.categoryColumns] : [];
  }
}
